type UserRow = {
  id: string
  waterCard: string
  name: string
  address: string
  date: string
  activity: string
}

export const userRows : UserRow[] = []
